import addError from '../../../utils/error.jsx';

export function request(id, data) {
    return {
        type: 'STAFF_UPDATE_REQUEST',
        id,
        data
    };
}

export function error(id, errors) {
    addError(errors);
    return {
        type: 'STAFF_UPDATE_ERROR',
        id,
        errors
    };
}

export function finish(id, data) {
    return {
        type: 'STAFF_UPDATE_FINISH',
        id,
        data
    };
}
